module.exports = __webpack_public_path__ + "img/lake-village-map--es.8ec879ed.png";